// SEO 工具函数
export const setPageTitle = (title) => {
  document.title = title ? `${title} - 希航留学` : '希航留学 - 马来西亚留学专业服务机构';
};

export const setPageDescription = (description) => {
  const metaDescription = document.querySelector('meta[name="description"]');
  if (metaDescription) {
    metaDescription.setAttribute('content', description);
  }
};

export const setPageKeywords = (keywords) => {
  const metaKeywords = document.querySelector('meta[name="keywords"]');
  if (metaKeywords) {
    metaKeywords.setAttribute('content', keywords);
  }
};

// 页面 SEO 配置
export const pageSEO = {
  home: {
    title: '希航留学 - 马来西亚留学专业服务机构',
    description: '希航留学是马来西亚留学行业的佼佼者，拥有10年留学申请经验，服务超过1000+学生。提供完整的留学服务体系：留学咨询、申请、签证办理、语言培训、接机接待等。',
    keywords: '马来西亚留学,希航留学,留学申请,留学咨询,马来西亚大学,留学签证,语言培训,接机服务,留学中介,马来西亚教育,留学规划,个性化留学,管家服务,留学经验'
  },
  universities: {
    title: '马来西亚大学推荐 - 希航留学',
    description: '精选马来西亚优质大学，包括马来亚大学、博特拉大学、国民大学等知名院校。希航留学为您提供详细的大学信息和申请指导。',
    keywords: '马来西亚大学,马来亚大学,博特拉大学,国民大学,马来西亚高校,大学排名,留学申请,希航留学'
  },
  programs: {
    title: '马来西亚留学专业推荐 - 希航留学',
    description: '涵盖商科、工程、医学、艺术等各个领域的马来西亚留学专业推荐。希航留学根据您的兴趣和职业规划，为您推荐最适合的专业。',
    keywords: '马来西亚专业,留学专业,商科,工程,医学,艺术,专业推荐,希航留学,职业规划'
  },
  services: {
    title: '留学服务 - 希航留学',
    description: '希航留学提供完整的留学服务体系：留学咨询、申请指导、签证办理、语言培训、接机接待、住宿安排等一站式服务。',
    keywords: '留学服务,留学咨询,申请指导,签证办理,语言培训,接机服务,住宿安排,一站式服务,希航留学'
  },
  about: {
    title: '关于我们 - 希航留学',
    description: '希航留学拥有10年留学申请经验，服务超过1000+学生。我们按照学生的个人情况规划留学方案，保证做到因才施教，实现学生的个性化发展。',
    keywords: '关于希航留学,留学经验,个性化发展,因才施教,学生服务,留学规划,希航留学团队'
  },
  contact: {
    title: '联系我们 - 希航留学',
    description: '希航留学专业团队为您提供一对一留学咨询服务。立即联系我们，开启您的马来西亚留学之旅。',
    keywords: '联系希航留学,留学咨询,一对一服务,马来西亚留学,希航留学联系方式'
  },
  applicationQuery: {
    title: '申请进度查询 - 希航留学',
    description: '查询您的马来西亚留学申请进度，实时了解申请状态。希航留学为您提供透明的申请流程跟踪服务。',
    keywords: '申请进度查询,留学申请状态,申请跟踪,希航留学,马来西亚留学申请'
  }
};

// 设置页面 SEO
export const setPageSEO = (pageKey) => {
  const seo = pageSEO[pageKey];
  if (seo) {
    setPageTitle(seo.title);
    setPageDescription(seo.description);
    setPageKeywords(seo.keywords);
  }
};
